import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=6cf6ce31&"
import script from "./dashboard.js?vue&type=script&lang=js&"
export * from "./dashboard.js?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
